import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';
import './LoginModal.css';

function LoginModal({ isOpen, onClose }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [apiKey, setApiKey] = useState('');
  const [error, setError] = useState('');
  const [isLogin, setIsLogin] = useState(true);
  const { login, loginWithGoogle, updateApiKey } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    try {
      if (isLogin) {
        await login(email, password);
      } else {
        await createUserWithEmailAndPassword(auth, email, password);
      }
      if (apiKey) {
        updateApiKey(apiKey);
      }
      onClose();
    } catch (error) {
      setError(isLogin 
        ? 'Failed to login. Please check your credentials.' 
        : 'Failed to create account. Email might be in use.'
      );
    }
  };

  const handleGoogleLogin = async () => {
    try {
      await loginWithGoogle();
      if (apiKey) {
        updateApiKey(apiKey);
      }
      onClose();
    } catch (error) {
      setError('Failed to login with Google.');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal">
        <button className="close-button" onClick={onClose}>×</button>
        <h2>{isLogin ? 'Login' : 'Sign Up'}</h2>
        {error && <div className="error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength="6"
            />
          </div>
          <div className="form-group">
            <label>OpenAI API Key (optional)</label>
            <input
              type="password"
              value={apiKey}
              onChange={(e) => setApiKey(e.target.value)}
              placeholder="sk-..."
            />
            <small className="api-key-help">
              Your API key will be stored securely in your browser
            </small>
          </div>
          <button type="submit" className="login-button">
            {isLogin ? 'Login' : 'Sign Up'}
          </button>
        </form>

        <div className="separator">
          <span>or</span>
        </div>

        <button 
          onClick={handleGoogleLogin}
          className="google-login-button"
          type="button"
        >
          <img 
            src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" 
            alt="Google logo" 
          />
          Continue with Google
        </button>

        <div className="auth-toggle">
          <button onClick={() => setIsLogin(!isLogin)} className="toggle-button">
            {isLogin 
              ? "Don't have an account? Sign up" 
              : "Already have an account? Login"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default LoginModal;

